



















import VueOptions from '@utils/VueOptions'

settings =
  name: "Gallery"

  vue:
    props: ['show', 'currentPosition', 'images']

    computed:
      currentImageURL: -> @images[@currentPosition]
      isFirstImage: -> @currentPosition is 0
      isLastImage: -> @currentPosition is (@images.length - 1)

    methods:
      hiToggleVisibility: -> @$emit('update:show', !@show)
      hiPrevImage: -> @$emit('update:currentPosition', @currentPosition - 1) unless @isFirstImage
      hiNextImage: -> @$emit('update:currentPosition', @currentPosition + 1) unless @isLastImage

export default VueOptions.vue settings
